import type { PropsWithChildren } from "react";
import { Card, createStyles, makeStyles } from "@material-ui/core";

import theme from "theme";

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      minHeight: "250px", // set for max height of any child (SubaccountSelection at writing)
      padding: theme.spacing(3),
    },
  }),
);

const StepContainer = ({ children }: PropsWithChildren) => {
  const classes = useStyles();
  return <Card className={classes.container}>{children}</Card>;
};

export default StepContainer;
